import React, { useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  GridSection,
  GridEleven,
  GridLeft,
  GridRight,
  DialogHeader,
  DialogHeading,
} from '../../Episode.Styled';
import Box from '@mui/material/Box';
import {
  dateFormatPdf,
  dateTimeFormat,
  westCarePdfHeading,
  westCarePdfTitle,
} from '../../../../constants';
import FormTextFieldPdf from '../../../common/Forms/FormTextFieldPdf';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { setAuthPdfPrint } from '../../../../redux/episode/authTab/authPdfSlice';
import Checkbox from '@mui/material/Checkbox';
import FormCheckboxPdf from '../../../common/Forms/FormCheckboxPdf';
import Button from '@mui/material/Button';
import { useReactToPrint } from 'react-to-print';

const AuthPdfDialog = (props) => {
  const dispatch = useDispatch();
  const authPdfPrint = useSelector((state) => state?.authPdfForm?.authPdfPrint);
  const { open, setOpen, openAuthPdfBackdrop, authData } = props;
  const authPdfForm = useSelector((state) => state?.authPdfForm?.data);

  //console.log('### authPdfForm');
  //console.log(authPdfForm);
  
  let modRes = {};
  let modOtp = {};
  let approvedDays = 0;
  
  if (authPdfForm) {
    const authStartDate = new Date(
      authPdfForm?.STOPAuthorization?.authorizationStartDate
    );
    const authEndDate = new Date(
      authPdfForm?.STOPAuthorization?.authorizationEndDate
    );

    modRes = authData?.data?.filter(
      (a) =>
        a.authStartDate === authStartDate.toLocaleDateString('es-pa') &&
        a.cboModId !== 'O-OPT' &&
        a.cboModId !== 'ODF' &&
        a.cboModId !== 'DPI' &&
        a.cboModId !== 'SOP'
    )[0];

    modOtp = authData?.data?.filter(
      (a) =>
        a.authStartDate === authStartDate.toLocaleDateString('es-pa') &&
        (a.cboModId === 'O-OPT' ||
          a.cboModId === 'ODF' ||
          a.cboModId === 'DPI' ||
          a.cboModId === 'SOP')
    )[0];

    //console.log('### modRes');
    //console.log(modRes);

    //console.log('### modOtp');
    //console.log(modOtp);
    const rateStartDate = new Date(modRes?.authRateI?.mthDateStart);
    const rateEndDate = new Date(modRes?.authRateI?.mthDateEnd);
    const approvedStartDate =
      authStartDate < rateStartDate ? rateStartDate : authStartDate;
    const approvedEndDate =
      authEndDate < rateEndDate ? authEndDate : rateEndDate;
    const oneDay = 24 * 60 * 60 * 1000;
    approvedDays =
      Math.round(Math.abs((approvedStartDate - approvedEndDate) / oneDay)) + 1;
  }

  const participantInformationData1 = [
    {
      title: 'Name :',
      text: authPdfForm?.participantInformation?.name,
    },
  ];

  const participantInformationData2 = [
    {
      title: 'DOB :',
      text: moment(authPdfForm?.participantInformation?.DOB)
        .format(dateFormatPdf)
        .split('T')[0],
    },
    {
      title: 'CDC No :',
      text: authPdfForm?.participantInformation?.CDCNo,
    },
  ];

  const participantInformationData3 = [
    {
      title: 'Registrant 290 :',
      text: authPdfForm?.participantInformation?.registrant290 ? 'Yes' : 'No',
    },
    {
      title: 'CCCMS :',
      text: authPdfForm?.STOPAuthorization?.CCCMS ? 'Yes' : 'No',
    },
  ];

  const participantInformationData4 = [
    {
      title: 'Parole Date :',
      text: authPdfForm?.participantInformation?.paroleDate ? 
              moment(authPdfForm?.participantInformation?.paroleDate)
              .format(dateFormatPdf)
              .split('T')[0] : '',
    },
    {
      title: 'Parole Agent :',
      text: authPdfForm?.participantInformation?.paroleAgent,
    },
  ];

  const cBPAuthorizationData = [
    {
      title: 'Authorization Start Date :',
      text: moment(authPdfForm?.STOPAuthorization?.authorizationStartDate)
        .format(dateFormatPdf)
        .split('T')[0],
    },
    {
      title: 'Authorization End Date :',
      text: moment(authPdfForm?.STOPAuthorization?.authorizationEndDate)
        .format(dateFormatPdf)
        .split('T')[0],
    },
    {
      title: 'Number days from Start to End Date :',
      text: authPdfForm?.STOPAuthorization?.numberDaysfromStarttoEndDate,
    },
  ];

  const cBPAuthorizationCheckBoxData = [
    {
      label: 'Initial',
      checked: authPdfForm?.STOPAuthorization?.PLCType === 1 ? true : false,
    },
    {
      label: 'Standard',
      checked: authPdfForm?.STOPAuthorization?.PLCType === 3 ? true : false,
    },
    {
      label: 'Secondary',
      checked: authPdfForm?.STOPAuthorization?.PLCType === 2 ? true : false,
    },
  ];

  const residentialData = [
    {
      title: 'Program Name :',
      text: modRes?.cboName,
      multiline: true,
      rows: 3
    },
    {
      title: 'Modality :',
      text: modRes?.modality,
    },
    {
      title: 'Address :',
      text: modRes?.orgAdr,
    },
    {
      title: 'City :',
      text: modRes?.orgCity,
    },
    {
      title: 'Zip :',
      text: modRes?.orgZip,
    },
    {
      title: 'Contact name :',
      text: modRes?.cntKey,
    },
    {
      title: 'Phone :',
      text: modRes?.cntPhone,
    },
    {
      title: 'Fax :',
      text: modRes?.cntFax,
    },
  ];

  const nonresidentialData = [
    {
      title: 'Program Name :',
      text: modOtp?.cboName,
    },
    {
      title: 'Modality :',
      text: modOtp?.modality,
    },
    {
      title: 'Address :',
      text: modOtp?.orgAdr,
    },
    {
      title: 'City :',
      text: modOtp?.orgCity,
    },
    {
      title: 'Zip :',
      text: modOtp?.orgZip,
    },
    {
      title: 'Contact name :',
      text: modOtp?.cntKey,
    },
    {
      title: 'Phone :',
      text: modOtp?.cntPhone,
    },
    {
      title: 'Fax :',
      text: modOtp?.cntFax,
    },
  ];

  const residentialAdditionalData = [
    {
      title: 'Approved Length of Stay:',
      //text: `${modRes?.authRateI?.cboAthDayQty} days`,
      text: `${approvedDays} days`,
    },
  ];

  const approvedResRate = [
    {
      title: 'Approved Rate:',
      text: `${
        modRes?.authRateI?.rate
          ? (modRes?.authRateI?.rate).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })
          : ''
      } per day x ${approvedDays}`,
    },
  ];

  const totalRes = [
    {
      title: 'Total Max Cost:',
      text: `${
        modRes?.authRateI?.rate
          ? (modRes?.authRateI?.rate * approvedDays).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })
          : ''
      }`,
    },
  ];

  const maxDischarge = [
    {
      title:  moment(authPdfForm?.STOPAuthorization?.authorizationEndDate)
        .format(dateFormatPdf)
        .split('T')[0],
      text: ''
    },
  ];

  const caseManagerConformatationLeftData = [
    {
      title: 'Case Manager :',
      text: authPdfForm?.caseManagerConfirmation?.caseManagerName,
    },
    {
      title: 'Office Location :',
      text: authPdfForm?.caseManagerConfirmation?.officeLocation,
    },
  ];

  const caseManagerConformatationRightData = [
    {
      title: 'Signature :',
      text: '',
    },
    {
      title: 'Date :',
      text: authPdfForm?.caseManagerConfirmation?.Date
        ? moment(authPdfForm?.caseManagerConfirmation?.Date)
            .format(dateFormatPdf)
            .split('T')[0]
        : '',
    },
  ];

  const supervisorAuthorizationLeftData = [
    {
      title: 'Supervisor :',
      text: authPdfForm?.superviserAuthorization?.SupervisorName,
    },
    {
      title: 'Title :',
      text: authPdfForm?.superviserAuthorization?.SupervisorTitle,
    },
  ];

  const supervisorAuthorizationRightData = [
    {
      title: 'Signature :',
      text: '',
    },
    {
      title: 'Date :',
      text: authPdfForm?.superviserAuthorization?.Date
        ? moment(authPdfForm?.superviserAuthorization?.Date)
            .format(dateFormatPdf)
            .split('T')[0]
        : '',
    },
  ];

  const clinicalInformationCheckBoxData = [
    {
      label: 'Relapsed Same Episode',
      checked: authPdfForm?.clinicalInformation?.relapse === '1' ? true : false,
    },
    {
      label: 'Relapsed New Episode',
      checked: authPdfForm?.clinicalInformation?.relapse === '2' ? true : false,
    },
  ];

  const handleClose = () => {
    setOpen(false);
    dispatch(setAuthPdfPrint(false));
  };

  //useEffect(() => {
  //  if (authPdfPrint) {
  //    window.print();
  //  }
  //}, [authPdfPrint]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Dialog fullScreen open={open} onClose={setOpen}>
      {openAuthPdfBackdrop ? (
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={openAuthPdfBackdrop}
        >
          <CircularProgress />
        </Backdrop>
      ) : (
        <>
          <DialogHeader>
            <DialogHeading variant="h5"></DialogHeading>
            <Box>
              <Button variant="contained" onClick={() => handlePrint()}>
                Print
              </Button>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogHeader>
          <Grid container ref={componentRef}>
            <GridSection mt={1} mx={2} container spacing={1}>
              <Grid item xs={5}>
                <Typography variant="h4">{westCarePdfHeading}</Typography>
              </Grid>
              <Grid item xs={5}>
                {authPdfForm?.reviewedBy && 
                  <Typography variant="body">
                    Reviewed By: {authPdfForm?.reviewedBy} on{' '}
                    {moment(authPdfForm?.reviewedDate).format(dateFormatPdf)}
                  </Typography>
                }  
              </Grid>
              <Grid item xs={2}>
                <Typography variant="h6">
                  Episode ID: {authPdfForm?.episodeID}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body">{westCarePdfTitle}</Typography>
              </Grid>
            </GridSection>

            {/** top boxes **/}
            <GridSection mx={2} container spacing={1}>
              <GridLeft item xs={6}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="h6" fontWeight="800">
                      Participant Information
                    </Typography>
                    {participantInformationData1?.map((item, index) => (
                      <FormTextFieldPdf
                        key={index}
                        title={item.title}
                        defaultValue={item.text}
                      />
                    ))}
                  </Grid>
                  <Grid pt={1} item xs={5.5}>
                    {participantInformationData2?.map((item, index) => (
                      <FormTextFieldPdf
                        key={index}
                        title={item.title}
                        defaultValue={item.text}
                        width={true}
                      />
                    ))}
                  </Grid>
                  <Grid pt={1} item xs={6.5}>
                    {participantInformationData3?.map((item, index) => (
                      <FormTextFieldPdf
                        key={index}
                        title={item.title}
                        defaultValue={item.text}
                        width={true}
                      />
                    ))}
                  </Grid>
                  <Grid item xs={12}>
                    {participantInformationData4?.map((item, index) => (
                      <FormTextFieldPdf
                        key={index}
                        title={item.title}
                        defaultValue={item.text}
                        width={true}
                      />
                    ))}
                  </Grid>
                </Grid>
              </GridLeft>
              <GridRight item xs={6}>
                <Typography variant="h6" fontWeight="800">
                  STOP Authorization
                </Typography>
                <Box style={{ display: 'flex' }}>
                  {cBPAuthorizationCheckBoxData?.map((item, index) => (
                    <FormCheckboxPdf key={index} item={item} />
                  ))}
                </Box>
                {cBPAuthorizationData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                    width={true}
                  />
                ))}
                <Typography variant="body2">
                  (This authorization expires 14 days from above date)
                </Typography>
              </GridRight>
            </GridSection>

            <GridSection mx={2} container spacing={0}>
              <Grid item xs={6}>
                <FormTextFieldPdf
                  title="Referral Source Information :"
                  defaultValue={
                    authPdfForm?.referralOrganization?.startsWith('NSG')
                      ? 'NSG'
                      : 'SAP'
                  }
                  width={true}
                />
              </Grid>
              <Grid item xs={6}>
                <FormTextFieldPdf
                  title="Referral Organization :"
                  defaultValue={authPdfForm?.referralOrganization}
                  width={true}
                />
              </Grid>
            </GridSection>

            <GridSection mx={2} container spacing={1}>
              <GridLeft item xs={6}>
                <Typography variant="h6" fontWeight="800">
                  Residential/Sober Living Program CBP ID:{' '}
                  <u>{modRes?.cbpId}</u>
                </Typography>
                {residentialData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                    multiline={item.multiline}
                    rows={item.rows}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridLeft>
              <GridRight item xs={6}>
                <Typography variant="h6" fontWeight="800">
                  Non-Residential Program CBP ID : <u>{modOtp?.cbpId}</u>
                </Typography>
                {nonresidentialData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridRight>
            </GridSection>

            <GridSection mx={2} container spacing={1}>
              <GridLeft item xs={6}>
                <Box>
                  {residentialAdditionalData?.map((item, index) => (
                    <FormTextFieldPdf
                      key={index}
                      title={item.title}
                      defaultValue={item.text}
                      width={true}
                    />
                  ))}
                </Box>
                <Box>
                  {approvedResRate?.map((item, index) => (
                    <FormTextFieldPdf
                      key={index}
                      title={authPdfForm?.resident.FY + ' ' + item.title}
                      defaultValue={item.text}
                      width={true}
                     />
                  ))}
                </Box>
                <Box>
                  {totalRes?.map((item, index) => (
                    <FormTextFieldPdf
                      key={index}
                      title={authPdfForm?.resident.FY + ' ' + item.title}
                      defaultValue={item.text}
                      width={true}
                    />
                  ))}
                </Box>
                <Box pt={0}>
                  <Typography variant="body2">
                  {'* The Max Discharge Date is ' + moment(authPdfForm?.STOPAuthorization?.authorizationEndDate)
                                                    .add(1, 'd')
                                                    .format(dateFormatPdf)
                                                    .split('T')[0] +
                                                    ' (one day after authorization end date)'
                  }
                </Typography>
                </Box>
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridLeft>
              <GridRight item xs={6}>
                {modOtp && (
                  <>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Box>
                          <Typography variant="body2">GROUP</Typography>
                        </Box>
                        <Box>
                          <Typography variant="body2">Min: Per Week</Typography>
                        </Box>
                        <Box>
                          <Typography variant="body">
                            Max: {modOtp?.authRateOtp?.sapAthMaxGrpUnits} Per
                            Week
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="body">
                            Rate:{' '}
                            {modOtp?.authRateOtp?.gRate
                              ? modOtp.authRateOtp.gRate.toLocaleString(
                                  'en-US',
                                  {
                                    style: 'currency',
                                    currency: 'USD',
                                  }
                                )
                              : ''}{' '}
                            per group
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box>
                          <Typography variant="body">IND</Typography>
                        </Box>
                        <Box>
                          <Typography variant="body">Min: Per Week</Typography>
                        </Box>
                        <Box>
                          <Typography variant="body">
                            Max: {modOtp?.authRateOtp?.sapAthMaxIndUnits} Per
                            Week
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="body">
                            Rate:{' '}
                            {modOtp?.authRateOtp?.iRate
                              ? (modOtp?.authRateOtp?.iRate).toLocaleString(
                                  'en-US',
                                  {
                                    style: 'currency',
                                    currency: 'USD',
                                  }
                                )
                              : ''}{' '}
                            a session
                          </Typography>
                        </Box>
                      </Grid>
                      <Box>
                        <Typography variant="body" p={2}>
                          FY {modOtp?.authRateOtp?.mth_FyID} Total Maximum Cost{' '}
                          <u>
                            {(
                              modOtp?.authRateOtp?.gRate *
                                modOtp?.authRateOtp?.sapAthMaxGrpUnits *
                                (approvedDays / 7) +
                              modOtp?.authRateOtp?.iRate *
                                modOtp?.authRateOtp?.sapAthMaxIndUnits *
                                (approvedDays / 7)
                            ).toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            })}
                          </u>
                        </Typography>
                      </Box>
                      <Box pl={2}>
                        <Typography variant="body2">
                        {'* Discharge Date must be on or before the authorization end date of ' + moment(authPdfForm?.STOPAuthorization?.authorizationEndDate)
                                                          .format(dateFormatPdf)
                                                          .split('T')[0] 
                        }
                        </Typography>
                      </Box>
                    </Grid>
                    <Box style={{ marginBottom: '10px' }}></Box>
                  </>
                )}
              </GridRight>
            </GridSection>
            {/**
            <GridSection mx={2} container spacing={1}>
              <GridLeft item xs={12}>
                <Typography variant='h6' fontWeight='800'>Clinical Information</Typography>
                <Box style={{ display: 'flex' }}>
                  {clinicalInformationCheckBoxData?.map((item, index) => (
                    <FormCheckboxPdf
                      key={index}
                      item={item}
                    />
                  ))}
                </Box>
                <Typography variant='h6' mb={-1}>
                  Treatement Recommendations (includes special conditions of
                  parole)
                </Typography>
                <FormTextFieldPdf
                  defaultValue={
                    authPdfForm?.clinicalInformation?.treatmentRecommendations
                  }
                />
                <Box style={{ marginBottom: '4px' }}></Box>
              </GridLeft>

            </GridSection>
            **/}
            <GridSection mx={2} container spacing={1}>
              <GridEleven item xs={12}>
                <Typography variant="h6" fontWeight="800">
                  Case Manager Confirmation
                </Typography>
              </GridEleven>
              <GridLeft item xs={6}>
                {caseManagerConformatationLeftData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridLeft>
              <GridRight item xs={6}>
                {caseManagerConformatationRightData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridRight>
            </GridSection>
            <GridSection mx={2} container spacing={1}>
              <GridEleven item xs={12}>
                <Typography variant="h6" fontWeight="800">
                  Supervisor Authorization
                </Typography>
              </GridEleven>
              <GridLeft item xs={6}>
                {supervisorAuthorizationLeftData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridLeft>
              <GridRight item xs={6}>
                {supervisorAuthorizationRightData?.map((item, index) => (
                  <FormTextFieldPdf
                    key={index}
                    title={item.title}
                    defaultValue={item.text}
                  />
                ))}
                <Box style={{ marginBottom: '10px' }}></Box>
              </GridRight>
            </GridSection>
            <GridSection mt={1} mx={2} container spacing={1}>
              <Grid item xs={12}>
                <Typography variant="body">
                  Printed: {moment(new Date()).format(dateTimeFormat)}
                </Typography>
              </Grid>
            </GridSection>
          </Grid>
        </>
      )}
    </Dialog>
  );
};

export default AuthPdfDialog;
